import { Injectable } from '@angular/core';
import { OrderAdDetailStatus } from '@core/enums/order-ad-detail-status';
import { OrderStatus } from '@core/enums/order-status';
import { OrderAdDetail } from '@core/models/order-ad-detail.model';
import { Order } from '@core/models/order.model';

@Injectable({
	providedIn: 'root'
})
export class StatusService {

	constructor () { }

	doesOrderHaveStatus(order: Order, orderStatus: OrderStatus): boolean {

		if (order && order.orderHeader && order.orderHeader.statusFlags && orderStatus) {
			return order.orderHeader.statusFlags.some(status => status.toUpperCase() === orderStatus.toUpperCase());
		}

		return false;
	}

	doesAnyAdDetailHaveStatus(order: Order, adDetailStatus: OrderAdDetailStatus): boolean {

		if (order && order.orderAdDetails) {
			return order.orderAdDetails.some((adDetail: OrderAdDetail) => {
				return adDetail.statusFlags.some(status => status.toUpperCase() === adDetailStatus.toUpperCase());
			});
		}

		return false;
	}

	doesAdDetailHaveStatus(adDetail: OrderAdDetail, adDetailStatus: OrderAdDetailStatus): boolean {

		if (adDetail && adDetail.statusFlags) {
			const adDetailStatusUppercase = adDetailStatus.toUpperCase();
			return adDetail.statusFlags.some((s: string) => s.toUpperCase() === adDetailStatusUppercase);
		}

		return false;
	}

	isOrderStatusEmpty(order: Order): boolean {
		if (order && order.orderHeader && order.orderHeader.statusFlags && order.orderHeader.statusFlags.length > 0) {
			return false;
		}

		return true;
	}

	canReserveOrder(order: Order): boolean {
		// CASS-169: Reserve will be visible when: The order contains any non-cancelled lines.
		if (order && !this.doesOrderHaveStatus(order, OrderStatus.Cancelled) && order.orderAdDetails && order.orderAdDetails.length > 0) {
			return true;
		}
		return false;
	}

	canConfirmOrder(order: Order): boolean {
		// CASS-169: Confirm will be visible when: The order contains any non-approval-pending, non-cancelled lines.
		if (order && !this.doesOrderHaveStatus(order, OrderStatus.Cancelled) && order.orderAdDetails && order.orderAdDetails.length > 0) {
			return order.orderAdDetails.some((orderLine: OrderAdDetail) => {
				if (!this.doesAdDetailHaveStatus(orderLine, OrderAdDetailStatus.ApprovalPending) && !this.doesAdDetailHaveStatus(orderLine, OrderAdDetailStatus.Cancelled)) {
					return true;
				}
				return false;
			});
		}
		return false;
	}
}
